import { AvField, AvForm } from "availity-reactstrap-validation"
import UseImageUploader from "components/imageUploader/useImageUploader"
import PropTypes from "prop-types"
import React, { useEffect, useState } from "react"
import { useDispatch } from "react-redux"
import { CardTitle, Col, Modal, ModalBody, Row } from "reactstrap"

// import Select from "react-select"
import { createTestimonial, updateTestimonial } from "store/actions"

const TestimonialModal = ({
  show,
  onCloseClick,
  updateData,
  imagesPreview,
  setImagesPreview,
}) => {
  const dispatch = useDispatch()

  const [rating, setRating] = useState(0)

  const handleClick = index => {
    setRating(index)
  }

  useEffect(() => {
    if (updateData?._id) {
      setRating(updateData?.rate || 0)
      setImagesPreview(updateData?.image)
    }
  }, [updateData])

  const handleValidSubmit = (e, v) => {
    const Update = {
      name: v?.name,
      message: v?.message,
      rate: rating,
      image: imagesPreview,
    }
    if (updateData?._id) {
      dispatch(updateTestimonial(Update, updateData?._id, onCloseClick))
    } else {
      const clientCreate = {
        name: v?.name,
        message: v?.message,
        rate: rating,
        image: imagesPreview,
      }

      dispatch(createTestimonial(clientCreate, onCloseClick))
    }
  }
  return (
    <Modal isOpen={show} toggle={onCloseClick} centered={true}>
      <ModalBody className="p-4">
        <CardTitle>
          {updateData?._id ? "Edit Testimonial" : "Add New Testimonial"}
        </CardTitle>
        <AvForm
          onValidSubmit={(e, v) => {
            handleValidSubmit(e, v)
          }}
        >
          <Row>
            <>
              <Col className="col-12 mb-2">
                <label>
                  Name <span className="text-danger"> *</span>
                </label>
                <AvField
                  name="name"
                  type="text"
                  placeholder="Enter Name "
                  value={updateData?.name}
                  validate={{
                    required: {
                      value: true,
                      errorMessage: "name is required",
                    },
                  }}
                />
              </Col>
            </>
          </Row>
          <Row>
            <Col className="col-6">
              <label>
                Rate <span className="text-danger">*</span>
              </label>
              <div>
                {[1, 2, 3, 4, 5].map(star => (
                  <i
                    key={star}
                    className={`fa fa-star ${
                      rating >= star ? "text-warning" : "text-secondary"
                    }`}
                    style={{
                      cursor: "pointer",
                      fontSize: "24px",
                      marginRight: "5px",
                    }}
                    onClick={() => handleClick(star)}
                  />
                ))}
              </div>
            </Col>
            <Col className="col-12 mt-2">
              <label>
                Message <span className="text-danger"> *</span>
              </label>
              <AvField
                name="message"
                type="textarea"
                placeholder="Enter Message "
                value={updateData?.message}
                validate={{
                  required: {
                    value: true,
                    errorMessage: " Message is required",
                  },
                  maxLength: {
                    value: 120,
                  },
                }}
              />
            </Col>
            <Col className="col-12 mt-2">
              <UseImageUploader
                imageSize={4}
                setImagesPreview={setImagesPreview}
                imagesPreview={imagesPreview}
                uploadUrl={"/focusmotors"}
              />
            </Col>
          </Row>

          <div className="d-flex justify-content-end align-items-center">
            <div className="text-center mt-3">
              <button
                type="button"
                className="btn btn-light ms-2"
                onClick={onCloseClick}
              >
                Cancel
              </button>
              <button type="submit" className="btn btn-warning ms-2">
                {updateData?._id ? "Save" : "Create"}
              </button>
            </div>
          </div>
        </AvForm>
      </ModalBody>
    </Modal>
  )
}

TestimonialModal.propTypes = {
  onCloseClick: PropTypes.func,
  show: PropTypes.any,
  updateData: PropTypes.any,
  setImagesPreview: PropTypes.any,
  imagesPreview: PropTypes.any,
}

export default TestimonialModal
